export enum ConvertationStatus {
    Idle = "Idle",
    InProgress = "InProgress",
    Success = "Success",
    Failed = "Failed",
    ServerError = "ServerError",
}

export enum ConvertationType {
    PdfA1_1_4 = "PdfA1_1_4",
    Pdf = "Pdf",
}
